import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const emails = [
  {
    day: "Immediate",
    subject: "🚨 You're Not Covered - Here's What That Means",
    body: "Hi [Name],\n\nThanks for taking our Renter's Insurance Quiz!\n\nRight now, if there's a fire in your building tonight, you lose everything. Your landlord's insurance covers the BUILDING, not your stuff. And renter's insurance costs less than $15/month.\n\nBook a quick 5-minute call - I'll get you a quote and answer all your questions.\n\nTalk soon,\nFelix Lopez"
  },
  {
    day: "Day 2",
    subject: "My apartment burned down. Here's what happened.",
    body: "I want to tell you about Jessica...\n\nShe lost $12,500 in belongings. Hotel cost $2,100. She still had to pay rent.\n\nTotal out-of-pocket: $16,400.\n\nIf she had renter's insurance? Cost: $15/month. Insurance would've paid $15,400.\n\nDon't be Jessica."
  },
  {
    day: "Day 4",
    subject: "What happens when someone sues you?",
    body: "Quick scenario:\n\nFriend trips in your apartment. Medical bills: $12,000.\n\nWithout insurance: They garnish your wages.\nWith insurance ($15/mo): Liability coverage pays the $12,000.\n\nLiability claims average $40,000-$60,000. Are you ready to pay that?"
  },
  {
    day: "Day 6",
    subject: "Does your lease require renter's insurance?",
    body: "California law changed - landlords can now REQUIRE renter's insurance.\n\nIf you don't have it, they can force-place insurance on you (charging you 2-3x the cost).\n\nGet your own policy BEFORE your landlord force-places one on you."
  },
  {
    day: "Day 7",
    subject: "Last call: Are you covered?",
    body: "I've reached out a few times...\n\nEvery week, I talk to renters who lost everything or got sued.\n\nAll of this is preventable for $12-18/month.\n\nIf I don't hear from you, I'll assume you're all set."
  }
];

export function EmailsView() {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8 bg-white p-6 rounded-xl border border-blue-200 shadow-sm flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Email Sequence Deliverables</h1>
            <p className="text-gray-500">View the 5-part automated email series.</p>
          </div>
          <a href="/#/" className="text-blue-600 hover:underline flex items-center">
            <SafeIcon icon={FiIcons.FiArrowLeft} className="mr-1" /> Back to App
          </a>
        </div>

        <div className="space-y-6">
          {emails.map((email, i) => (
            <div key={i} className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
              <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                <span className="font-semibold text-gray-700">{email.day}</span>
                <span className="text-sm bg-blue-100 text-blue-800 py-1 px-3 rounded-full">Automated</span>
              </div>
              <div className="p-6">
                <div className="mb-4 pb-4 border-b border-gray-100">
                  <p className="text-sm text-gray-500 mb-1">Subject:</p>
                  <p className="font-bold text-lg">{email.subject}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-2">Body Snippet:</p>
                  <pre className="whitespace-pre-wrap font-sans text-gray-700 bg-gray-50 p-4 rounded-lg border border-gray-100">
                    {email.body}
                  </pre>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}